import { FormGroup } from '@angular/forms';
import { PersonalDetailsForm } from './personal-details-form.interface';

export type PersonalDetailsFormValue = ReturnType<
  FormGroup<PersonalDetailsForm>['getRawValue']
>;
